import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <div className='overflow-hidden relative'>
      {/* <img src='/shadowbg-img.svg' alt='' className='absolute top-0 bottom-0 object-cover' /> */}
      <div className='py-16 pb-20 border-b-[1px] border-black10 relative overflow-hidden'>
        <div className='container'>
          <div className='grid grid-cols-3 justify-between sm:grid-cols-1'>
            <div className='logo sm:text-center sm:flex sm:justify-center sm:mb-5'>
              <a href='/' rel="noreferrer">
                <img src='/logo.svg' alt='Logo' />
              </a>
            </div>
            <div className='col-span-2'>
              <div className='flex gap-16 justify-between sm:gap-10 sm:flex-col'>
                <div className='flex gap-16'>
                  <div className='relative'>

                   <ul className='space-y-5 pt-5'>

                      {/* <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Real-Time Decision Log
                        </a>
                      </li>
                      <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Checks & Alerts
                        </a>
                      </li>
                      <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Execution AI Agents
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  {/* <div className='relative'>
                    <h4 className='font-sora text-[12px] text-combinationsColor uppercase tracking-[.25em]'>
                      Resources
                    </h4>
                    <ul className='space-y-5 pt-5'>
                      <li>
                        <a
                          rel="noreferrer"
                          href='#pricing'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Pricing
                        </a>
                      </li>
                       <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Blog
                        </a>
                      </li> 
                    </ul>
                  </div> */}
                </div> 
                <div className='flex gap-16 w-full'>
                  <div className='relative'>
                    <h4 className='font-sora text-[12px] text-combinationsColor uppercase tracking-[.25em]'>
                      Company
                    </h4>
                    <ul className='space-y-5 pt-5'>
                      <li>
                        <a
                          rel="noreferrer"
                          href='https://2fdzq6.share-eu1.hsforms.com/2FzkpEW-pQWuU0gkwVxvdbw?utm_source=website&utm_medium=footer&utm_campaign=investor'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Investor Newsletter
                        </a>
                      </li>
                      {/* <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Why Pale
                        </a>
                      </li>
                      <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          About
                        </a>
                      </li>
                      <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Careers
                        </a>
                      </li>
                      <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Referral Program
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  {/* <div className='relative'>
                    <h4 className='font-sora text-[12px] text-combinationsColor uppercase tracking-[.25em]'>
                      Resources
                    </h4>
                    <ul className='space-y-5 pt-5'>
                      <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Blog
                        </a>
                      </li>
                      <li>
                        <a
                          href='#'
                          className='text-primary hover:text-primary transition-colors font-noto font-normal'
                        >
                          Events
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='py-6'>
        <div className='container'>
          <div className='flex items-center gap-20 relative sm:gap-5 sm:flex-col sm:text-center'>
            <p className='font-noto text-[12px] text-black40'>
              © Pale 2025. All rights reserved.
            </p>
            <ul className='space-x-5 flex pl-20 sm:pl-0'>
              <li>
                <Link
                  to='/terms/privacy'
                  className='text-primary hover:text-primary transition-colors font-noto text-[12px] sm:text-[12px]'
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to='/terms/merchant'
                  className='text-primary hover:text-primary transition-colors font-noto text-[12px] sm:text-[12px]'
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
